import { render } from "./approved.vue?vue&type=template&id=ca85f728&scoped=true"
import script from "./approved.vue?vue&type=script&lang=js"
export * from "./approved.vue?vue&type=script&lang=js"

import "./approved.vue?vue&type=style&index=0&id=ca85f728&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca85f728"]])

export default __exports__